/* eslint-disable max-len */
import React, { Fragment, Component } from 'react';
import { get } from 'lodash';
import { withLocalize } from 'react-localize-redux';
import axios from 'axios';
import styled from 'styled-components';
import { hlog } from './util';
import { BingMap } from './constant';

let detailedLat = null;
let detailedLong = null;
class BingMaps extends Component {
  state = {
    detailed: false
  }

  componentDidMount() {
    this.getDetailed();
  }

  getDetailed = () => {
    const { location } = this.props;
    const address = get(location, 'value.address');
    const { key } = BingMap;
    const countryRegion = get(address, 'countryRegion', '-');
    const adminDistrict = get(address, 'adminDistrict', '-');
    const locality = get(address, 'locality', '-');
    const postalCode = get(address, 'postalCode', '-');
    const detailAddress = get(address, 'addressLine', '-').split(' ').join('/');
    const API = `https://dev.virtualearth.net/REST/v1/Locations?CountryRegion=${countryRegion}&adminDistrict=${adminDistrict}&locality=${locality}&postalCode=${postalCode}&addressLine=${detailAddress}&key=${key}`;
    axios.get(API).then(res => {
      if (res.status === 200) {
        const detailedCoor = res.data.resourceSets[0].resources[0].point.coordinates;
        [detailedLat, detailedLong] = detailedCoor;
        this.setState({
          detailed: true
        });
      } else {
        hlog(res.status);
      }
    }).catch((err) => hlog(err));
  }

  render() {
    const { location, translate } = this.props;
    const { detailed } = this.state;
    const coordinates = get(location, 'value.coordinates');
    const [lat, long] = coordinates || [];
    const address = get(location, 'value.address');
    return (
      <div
        ref={container => {
          if (this) {
            this.container = container;
          }
        }}
      >
        {address && (
          <div className='eventDetail_main_infobar_location_addressWrapper'>
            {/* <span className='eventDetail_main_infobar_location_address'>{address.formattedAddress}</span> */}
            {address.addressLine && (
              <span className='eventDetail_main_infobar_location_address'>{address.addressLine}</span>
            )}
            {address.addressLine2 && (
              <span className='eventDetail_main_infobar_location_address'>{address.addressLine2}</span>
            )}
            {address.locality && <span className='eventDetail_main_infobar_location_address'>{address.locality}</span>}
            {address.adminDistrict && (
              <span className='eventDetail_main_infobar_location_address'>{address.adminDistrict}, </span>
            )}
            {address.postalCode && (
              <span className='eventDetail_main_infobar_location_address'>{address.postalCode}</span>
            )}
            {address.countryRegion && (
              <span className='eventDetail_main_infobar_location_address'>{address.countryRegion}</span>
            )}
          </div>
        )}
        {detailed && !!detailedLat && !!detailedLong && (
          <Fragment>
            <div className='eventDetail_main_infobar_location_map_wrapper'>
              <iframe
                title='bing-map'
                className='eventDetail_main_infobar_location_map'
                frameBorder='0'
                src={`https://www.bing.com/maps/embed?h=200&w=300&cp=${detailedLat}~${detailedLong}&lvl=15&typ=s&sty=r&src=SHELL&FORM=MBEDV8`}
                scrolling='no'
              />

              <Container>
                <a
                  id='largeMapLink' rel='noopener noreferrer' target='_blank'
                  className='eventDetail_main_infobar_location_link'
                  href={`https://www.bing.com/maps?cp=${detailedLat}~${detailedLong}&amp;sty=r&amp;lvl=16&amp;FORM=MBEDLD`}
                >{translate('common.viewLargerMap')}
                </a> &nbsp; | &nbsp;
                <a
                  id='dirMapLink' rel='noopener noreferrer' target='_blank'
                  className='eventDetail_main_infobar_location_link'
                  href={`https://www.bing.com/maps/directions?cp=${detailedLat}~${detailedLong}4&amp;sty=r&amp;lvl=16&amp;rtp=~pos.${detailedLat}_${detailedLong}____&amp;FORM=MBEDLD`}
                >{translate('common.getDirections')}
                </a>
              </Container>
            </div>
          </Fragment>
        )}

        {!detailed && !!lat && !!long && (
          <Fragment>
            <div className='eventDetail_main_infobar_location_map_wrapper'>
              <iframe
                title='bing-map'
                className='eventDetail_main_infobar_location_map'
                frameBorder='0'
                src={`https://www.bing.com/maps/embed?h=200&w=300&cp=${lat}~${long}&lvl=15&typ=s&sty=r&src=SHELL&FORM=MBEDV8`}
                scrolling='no'
              />

              <Container>
                <a
                  id='largeMapLink' rel='noopener noreferrer' target='_blank'
                  className='eventDetail_main_infobar_location_link'
                  href={`https://www.bing.com/maps?cp=${lat}~${long}&amp;sty=r&amp;lvl=16&amp;FORM=MBEDLD`}
                >{translate('common.viewLargerMap')}
                </a> &nbsp; | &nbsp;
                <a
                  id='dirMapLink' rel='noopener noreferrer' target='_blank'
                  className='eventDetail_main_infobar_location_link'
                  href={`https://www.bing.com/maps/directions?cp=${lat}~${long}4&amp;sty=r&amp;lvl=16&amp;rtp=~pos.${lat}_${long}____&amp;FORM=MBEDLD`}
                >{translate('common.getDirections')}
                </a>
              </Container>
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}

const Container = styled.div`
white-space: nowrap; 
text-align: center; 
width: 300px; 
padding: 6px 0;
`;

export default withLocalize(BingMaps);



// WEBPACK FOOTER //
// ./src/components/common/bingMaps.js